import { EXERCISES_PATH } from '../../../../exercise/redux/constants/path'
import addInstanceToDomainListReduxUtil from '../../../../redux/utils/add-instance-to-domain-list'
import { getTypeExerciseUtil } from '../../utils'
import { getMusclesExerciseUtil } from '../../utils/get-muscles'

function afterCreateExerciseHook (instance, state) {
  const type = getTypeExerciseUtil(instance)
  const muscles = getMusclesExerciseUtil(instance)
  muscles.forEach(muscle => {
    state = addInstanceToDomainListReduxUtil({
      state,
      instance,
      domainListPath: `${EXERCISES_PATH.MUSCLE_TO_IDS}.${muscle}`
    })
  })
  state = addInstanceToDomainListReduxUtil({
    state,
    instance,
    domainListPath: `${EXERCISES_PATH.TYPE_TO_IDS}.${type}`
  })
  return state
}

export { afterCreateExerciseHook }
